export const AVRAM_YZER_ID = 15863;
export const SHVIRO_YZER_ID = 16218;
export const HOLON_YZER_ID = 11867;
export const HAVATZELET_YZER_ID = 17222;
export const YUVALIM_YZER_ID = 16137;
export const RASSCO_YZER_ID = 15836;
export const PISGAT_YZER_ID = 5816;
export const SHBIRO_NEVE_ZEMER_YZER_ID = 16212;
export const RASSCO_NEW_YZER_ID = 16831;

export const mapProjectToS3Folder = {
  [SHVIRO_YZER_ID]: 'shviro',
  [HOLON_YZER_ID]: 'holon',
  [AVRAM_YZER_ID]: 'avram',
  [HAVATZELET_YZER_ID]: 'havatzelet',
  [YUVALIM_YZER_ID]: 'yuvalim',
  [RASSCO_YZER_ID]: 'rassco',
  [RASSCO_NEW_YZER_ID]: 'rassco',
  [PISGAT_YZER_ID]: 'pisgat',
  [SHBIRO_NEVE_ZEMER_YZER_ID]: 'shbiro-neve-zemer',
};

export const CLIENTS_WITH_CONTACTS_CONSENT = [1000004];
export const AWS_PROJECTS_BUCKET = 'https://static.treedis.com/projects';
export const AWS_PUBLIC_BUCKET = 'https://static.treedis.com';

// Projects that currently support Balcony View
export const PROJECTS_WITH_BALCONY_VIEW: number[] = [
  RASSCO_YZER_ID,
  RASSCO_NEW_YZER_ID,
  PISGAT_YZER_ID,
  YUVALIM_YZER_ID,
];
